import {FC} from "react";
import {LoginContent} from "../components/login/LoginContent";
import {CentralContent} from "../components/central-content/CentralContent";
import {Page} from "./Page";

export const LoginPage: FC = () => {
  return <Page>
    <CentralContent>
      <LoginContent/>
    </CentralContent>
  </Page>
}
